import {FC} from 'react';
import {View, Text, StyleSheet, Image,Link} from '@react-pdf/renderer';
import {ISpot} from '../../../models/cleanUp';

const styles = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderColor: '#ccc',
        display: 'flex',
        flexDirection: 'column',
        paddingHorizontal: 4,
        paddingVertical: 4,
        alignItems: 'stretch',
    },
    images: {
        display: 'flex',
        flexDirection: 'row',
        gap: 3,
    },
    image: {
        width: 80,
        height: 80,
    },
    text: {
        fontFamily: 'Roboto',
        fontSize: 9,
        marginTop: 2,
    },
    labels: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
     imageWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    originalLink: {
        fontFamily: 'Roboto',
        fontSize: 7,
        color: 'gray',
        textDecoration: 'none',
        marginTop: 1,
    },
    noImageText: {
        fontFamily: 'Roboto',
        fontSize: 8,
        fontStyle: 'italic',
        marginTop: 2,
    },
});

interface IProps {
    spot: ISpot;
}
const ImageSpot: FC<IProps> = ({ spot }) => {
  return (
    <View style={styles.container} wrap={false}>
      <View style={styles.images}>
        {/* ─── BEFORE COLUMN ─── */}
        <View style={styles.imageWrapper}>
          <Image
            style={styles.image}
            src={spot.before.image_url || '/images/placeholder.jpg'}
          />
          <Text style={styles.text}>Before</Text>
          {spot.before.image_url ? (
            <Link
              src={spot.before.image_url}
              style={styles.originalLink}
            >
              see original size
            </Link>
          ) : (
            <Text style={styles.noImageText}>(No "Before" image)</Text>
          )}
        </View>

        {/* ─── AFTER COLUMN ─── */}
        <View style={styles.imageWrapper}>
          <Image
            style={styles.image}
            src={spot.after.image_url || '/images/placeholder.jpg'}
          />
          <Text style={styles.text}>After</Text>
          {spot.after.image_url ? (
            <Link
              src={spot.after.image_url}
              style={styles.originalLink}
            >
              see original size
            </Link>
          ) : (
            <Text style={styles.noImageText}>(No "After" image)</Text>
          )}
        </View>
      </View>
    </View>
  );
};


export default ImageSpot;
